import { DurationPicker } from './DurationPicker';

export default DurationPicker;
